export default {
    methods: {
        __(key, replace) {
            let translation, translationNotFound = true

            try {
                translation = key.split('.').reduce((t, i) => t[i] || null, window.translations)

                if (translation) {
                    translationNotFound = false
                }
            } catch (e) {
                translation = key
            }

            // if (translationNotFound) {
            //     translation = window.translations[window._locale]['json'][key]
            //         ? window._translations[window._locale]['json'][key]
            //         : key
            // }

            _.forEach(replace, (value, key) => {
                translation = translation.replace(':' + key, value)
            })

            return translation
        },
        appinfo(key) {
            try {
                return key.split('.').reduce((t, i) => t[i] || null, window.appinfo)
            } catch (e) {
                return key
            }
        },
        log(msg, data) {
            if (data) {
                console.log(msg, data);
            }else{
                console.log(msg);
            }
        },
        ucFirst(str) {
            if (typeof str !== 'string') return '';
            return str.charAt(0).toUpperCase() + str.slice(1);
        },
        cleanString(str) {
            return str.replace('_', ' ');
        },
        getPropertyValue(object, property) {
            if (!_.isObject(object)) return "";
            return object.hasOwnProperty(property) ? object[property] : '';
        },
        isUndefined(str) {
            return _.isUndefined(str);
        },
        isAuthorizedWithRedirect(entity, action) {
            return new Promise((resolve, reject) => {
                this.isAuthorized(entity, action)
                    .then(() => resolve())
                    .catch(() => this.$router.push({name: 'unauthorized'}))
            });
        },
        isAuthorized(entity, action) {
            return new Promise((resolve, reject) => {
                axios.get(`/user/check/${entity}/${action}`)
                    .then(response => {
                        if (response.status === 202 && response.data.authorized) {
                            resolve()
                        } else {
                            reject();
                        }
                    })
                    .catch(error => {
                        reject()
                    })
            });
        },
        getHtmlValue(value) {
            return Array.isArray(value) ?
                this.joinArrayValues(value) : value;
        }
    }
}
